import * as Types from '../constants/Types';

export const loginAction = (params) => ({type: Types.LOGIN_ACTION, params});
export const loginSuccess = (data) => ({type: Types.LOGIN_SUCCESS, data});
export const loginAuth = (authenticating) => ({type: Types.LOGIN_AUTHENTICATING, authenticating});

export const checkUserAction = (token) => ({type: Types.CHECK_USER_ACTION, token});
export const checkUserSuccess = (user) => ({type: Types.CHECK_USER_SUCCESS, user});

export const logoutAction = (params) => ({type: Types.LOGOUT_ACTION, params});
export const logoutSuccess = (data) => ({type: Types.LOGOUT_SUCCESS, data});

export const refreshTokenAction = (refreshToken) => ({type: Types.REFRESH_TOKEN_ACTION, refreshToken});